import { Button, Card, Col, Row } from "antd";
import { BackBtn } from "../../components/commonComponents";
import { getDocumentHierarchy } from "./components/actions";
import { useEffect, useState } from "react";
import { DocumentHierarchyModal } from "./components/modals/DocumentHierarchyModal";
import { HierarchyCard } from "./components/cards/HierarchyCard";

export default function DocumentHierarchy() {
    const [open,setOpen] = useState(false)
    const [openEdit,setOpenEdit] = useState(false)
    const [data,setData] = useState([])
    const [editData,setEditData] = useState(null)

    const reload = () => {
        getDocumentHierarchy().then(res => {
            setData(res)
        }).catch(err => {
            console.log(err)
        })
    }
    useEffect(() => {
        reload()
    }, [])
    const edit = (data) => {
        setEditData(data)
        setOpenEdit(true)
    }
    return(
        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'start', flexDirection: 'column', height:'100%'}}>
            <BackBtn  path='/admin' label='დაბრუნება' />
            <Card style={{width:'100%', height:'100%',boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)'}} title='დოკუმენტების სტრუქტურა'>
            <Row gutter={[16, 16]} justify='center'>     
                <Col span={24}>
                    <Button icon={<i className="fa-solid fa-folder-plus"></i>} type="primary" onClick={() => {setOpen(true)}}>დამატება</Button>
                </Col>
                {
                    data?.map((item,index) => (
                        <Col  key={index}>
                            <HierarchyCard data={item} edit={edit} />
                        </Col>
                    ))
                }
                </Row>
            </Card>
            {
                open && <DocumentHierarchyModal open={open} close={setOpen} reload={reload} />
            }
            {
                openEdit && <DocumentHierarchyModal open={openEdit} close={setOpenEdit} reload={reload} data={editData} />
            }
        </div>
    )
}